<template>
  <svg width="745" height="375" viewBox="0 0 745 375" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M58.1531 -69.4853C47.7364 17.3347 42.8667 204.335 106.721 257.775C186.54 324.576 177.367 113.831 187.526 82.1597C197.684 50.488 263.077 391.2 381.953 419.477C500.829 447.754 274.944 10.7958 348.756 -11.2071C422.568 -33.2101 664.266 389.134 703.852 511.995"
      :stroke="strokeColor"
      stroke-width="102.341"
      stroke-linecap="round"
    />
  </svg>
</template>

<script setup lang="ts">
const { strokeColor } = defineProps<{ strokeColor: string }>()
</script>
